import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Zap, Clock, Tag, Settings } from 'lucide-react';

interface TriggerNodeData {
  title?: string;
  description?: string;
  timeout?: number;
  color?: string;
  tags?: string[];
  keywords?: string[];
  isActive?: boolean;
}

export const TriggerNode = memo(({ data, isConnectable }: NodeProps<TriggerNodeData>) => {
  return (
    <div className={`px-4 py-2 shadow-md rounded-md bg-white border-2 ${
      data.isActive 
        ? 'border-green-400 bg-green-50' 
        : 'border-blue-200 hover:border-blue-400'
    } transition-colors duration-300`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <Zap 
            className={`h-4 w-4 mr-2 ${data.isActive ? 'text-green-500' : ''}`} 
            style={{ color: data.isActive ? undefined : data.color || '#3b82f6' }} 
          />
          <div className="text-sm font-medium text-gray-900">
            {data.title || 'Disparador'}
          </div>
        </div>
        <Settings className="h-4 w-4 text-gray-400" />
      </div>
      <div className="mt-2 text-sm text-gray-600">
        <div>
          {data.description || 'Se activa cuando se recibe un mensaje'}
        </div>
        
        {/* Palabras clave */}
        {data.keywords && data.keywords.length > 0 && (
          <div className="flex flex-wrap gap-1 mt-2">
            {data.keywords.map((keyword, index) => (
              <span 
                key={index}
                className="inline-flex items-center px-2 py-0.5 rounded text-xs bg-blue-100 text-blue-800"
              >
                <Tag className="h-3 w-3 mr-1" />
                {keyword}
              </span>
            ))}
          </div>
        )}
      </div>
      <Handle
        type="source"
        position={Position.Bottom}
        id="default"
        isConnectable={isConnectable}
        className={`w-3 h-3 ${data.isActive ? 'bg-green-500' : 'bg-blue-500'}`}
      />
    </div>
  );
});

TriggerNode.displayName = 'TriggerNode';